import { useContext } from 'react'
import {
  footerCategories,
  footerLocations,
  POST_JOB_LINK,
  SITE_MAP_SECTIONS
} from '../constants/all'
import useTranslation from '../hooks/useTranslation'
import ImageWithBasePath from './ImageWithBasePath'
import { getFooterAsPath } from '../utils/functions'
import { NextLink } from '../commonComponents/NextLink'
import { SharedContext } from '@/context/SharedContext'
import { SeekerContext } from '@/context/SeekerContext'

export const QuickAccessFooter = () => {
  const translation = useTranslation()
  const {
    setMenuClicked,
    setLocation,
    cookie,
    setScrollBar
  } = useContext(SharedContext);
  
  const {
    setBody,
    filterTitleIds,
    setFrom
  } = useContext(SeekerContext);
  

  const foterTitles = [
    { title: translation.quickAccessFooterFields.quickLinks, all: false },
    {
      title: translation.quickAccessFooterFields.categoryWiseJobs,
      all: true,
      subLinkText: translation.quickAccessFooterFields.viewAllCategories,
      subLinkDetails: {
        pathname: '/sitemap'
      },
      shortName: 'category'
    },
    {
      title: translation.quickAccessFooterFields.jobsByLocation,
      all: true,
      subLinkText: translation.quickAccessFooterFields.viewAllLocations,
      subLinkDetails: {
        pathname: '/sitemap'
      },
      shortName: 'location'
    }
  ]

  const bodyLinks = {
    [translation.quickAccessFooterFields.quickLinks]: [
      {
        title: translation.findAJob,
        path: 'locationSelectionPage',
        props: { as: `jobs-near-me` }
      },
      { title: translation.postAJob, path: POST_JOB_LINK }
    ],
    [translation.quickAccessFooterFields.categoryWiseJobs]: [
      {
        title: translation.design,
        path: '#',
        id: 9
      },
      {
        title: translation.administration,
        path: '#'
      },
      {
        title: translation.digitalMarketing,
        path: '#'
      },
      {
        title: translation.finance,
        path: '#',
        id: 15
      }
    ],
    [translation.quickAccessFooterFields.jobsByLocation]: [
      {
        title: translation.guntur,
        path: '#'
      },
      {
        title: translation.krishna,
        path: '#'
      },
      {
        title: translation.vishakapatnam,
        path: '#'
      },
      {
        title: translation.yadadri,
        path: '#'
      }
    ]
  }

  const socialMediaLogos = [
    { id: 1, logo: 'youTubeLogo', src: 'https://www.youtube.com/@lokaljobs7179' }
  ]
  const handleImageClick = () => {
    const url = 'https://www.youtube.com/@lokaljobs7179'
    window.open(url, '_blank')
  }
  const redirectHandler = async (header, title) => {
    setFrom('bottom_banner')
    if (title === translation.createAnAccount) {
      setMenuClicked(true)
      setScrollBar(false)
      return true
    } else if (title === translation.jobSearchAdvice) {
      return true
    } else if (title === translation.postAJob) {
      window?.open(process.env.NEXT_PUBLIC_APP_URL + 'hire', '_self')
      return true
    }
    if (header === translation.quickAccessFooterFields.jobsByLocation) {
      setLocation(footerLocations[title])
      cookie.set('location', footerLocations[title], { path: '/' })
      setBody({ apiBody: {}, selectedOptions: {} })
    } else if (header === translation.quickAccessFooterFields.categoryWiseJobs) {
      const bodyValue = { [filterTitleIds['Job Category']]: [footerCategories[title]] }
      setBody((prv) => ({
        ...prv,
        selectedOptions: bodyValue
      }))
    } else if (title === translation.findAJob) {
      setBody({ apiBody: {}, selectedOptions: {} })
    }
  }

  return (
    <div
      className="h-auto bg-[#262626] pt-[32px] pb-[33px] pl-[24px]"
      id="quick_access_footer_container"
    >
      <div id="qaf_appLogo" onClick={() => {}}>
        <ImageWithBasePath src="appLogo" height={20} width={100} alt="Lokal" />
      </div>
      {/* <div className="flex flex-col gap-y-[16px]">
        <div className="mt-[25px] font-noto-sans text-lg font-bold leading-[30.7px] tracking-[0.5px] text-[#8B8B8B]">
          Follow us
        </div>
        <div className="flex gap-x-[20px]">
          {socialMediaLogos.map((item, index) => {
            return (
              <ImageWithBasePath
                key={index}
                className="rounded-full"
                src={item.logo}
                height={40}
                width={40}
                alt="Lokal"
                onClick={handleImageClick}
              />
            )
          })}
        </div>
      </div> */}
      {foterTitles.map((item, index) => (
        <div key={index} id="qaf_content_div">
          <h2
            className="mt-[25px] mb-[0px] font-noto-sans text-lg font-bold leading-[30.7px] tracking-[0.5px] text-[#8B8B8B]"
            id={item.title}
          >
            {item.title}
          </h2>
          {bodyLinks[item.title]?.map((item1, index1) => (
            <div key={index1} id="body_links_div">
              <NextLink
                href={{
                  pathname: 'jobsFiltering',
                  query: { from: 'bottom_banner' }
                }}
                as={getFooterAsPath(item.title, item1.title, translation)}
                id={item1.title + index}
                onClick={async () => await redirectHandler(item.title, item1.title)}
              >
                <div className="mt-[16px] font-noto-sans text-base leading-[21.56px] tracking-[0.5px] text-[#E0E0E0]">
                  {item1.title}
                </div>
              </NextLink>
              {item.all && index1 === bodyLinks[item.title].length - 1 && (
                <NextLink
                  href={{
                    pathname: 'sitemap',
                    query: { elementTitle: SITE_MAP_SECTIONS?.[item?.shortName] }
                  }}
                  as={'jobs/sitemap'}
                  id="viewLocation"
                >
                  <div className="flex cursor-pointer items-center pt-[17.31px] pb-[16.69px]">
                    <div className="font-noto-sans font-bold text-[#FFBB00]">
                      {item.subLinkText}
                    </div>
                    <div className="flex items-center" id="qaf_right_arrow_yellow_icon">
                      <ImageWithBasePath
                        src="rightArrowYellowIcon"
                        height={24}
                        width={24}
                        alt="Right Arrow Icon"
                        className="mt-[2px]"
                      />
                    </div>
                  </div>
                </NextLink>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}